module.exports = require('../dist/shared');
